/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { approximateCountFiltersSchema } from './approximateCountFiltersSchema';

export const approximateCountRequestSchema = z.object({
  get filters() {
    return z.union([approximateCountFiltersSchema, z.null()]).optional();
  },
});
